import * as types from './actionsTypes';

export const getAvailableItemsAction = () => ({
  type: types.GET_AVAILABLE_ITEMS,
});
